import { z } from "zod/v4-mini";

import { FileModel, fileSchema } from "@/models/FileModel.ts";
import { Schema, cz } from "@/utils/zodUtils.ts";

export type PractitionerBillingStatus = "to_process" | "processed" | "error";
export type PractitionerBillingType = "retrocession_doctor" | "retrocession_steto" | "quotation";

type PractitionerInfo = {
  id: string;
  firstName: string;
  lastName: string;
};

export type PractitionerBilling = {
  id: string;
  file: FileModel;
  fileType: PractitionerBillingType;
  fileName: string;
  period: string;
  fileUploadDate: string;
  doctor?: PractitionerInfo;
  nurse?: PractitionerInfo;
  status: PractitionerBillingStatus;
};

const practitionerInfoSchema: Schema<PractitionerInfo> = cz.camelCaseObject({
  id: z.string(),
  first_name: z.string(),
  last_name: z.string(),
});

export const practitionerBillingSchema: Schema<PractitionerBilling> = cz.camelCaseObject({
  id: z.string(),
  file: fileSchema,
  file_type: z.literal(["retrocession_steto", "retrocession_doctor", "quotation"]),
  period: z.iso.date(),
  file_upload_date: cz.datetime(),
  doctor: cz.optional(practitionerInfoSchema),
  nurse: cz.optional(practitionerInfoSchema),
  status: z.literal(["to_process", "processed", "error"]),
  file_name: z.string(),
});

export const practitionerBillingStatusTranslation = (status: PractitionerBillingStatus) => {
  switch (status) {
    case "to_process":
      return "models.practitionerBillingStatus.toProcess";
    case "processed":
      return "models.practitionerBillingStatus.processed";
    case "error":
      return "models.practitionerBillingStatus.error";
  }
};

export const practitionerBillingTypeTranslation = (type: PractitionerBillingType) => {
  switch (type) {
    case "retrocession_doctor":
      return "models.practitionerBillingType.retrocessionDoctor";
    case "retrocession_steto":
      return "models.practitionerBillingType.retrocessionSteto";
    case "quotation":
      return "models.practitionerBillingType.quotation";
  }
};
